import jwtDecode from "jwt-decode";

class Auth {
  saveToken(_token) {
    localStorage.setItem("auth.token", JSON.stringify(_token));
  }

  getToken() {
    return JSON.parse(localStorage.getItem("auth.token"));
  }

  removeToken() {
    return localStorage.removeItem("auth.token");
  }

  isLoggedIn() {
    return !!this.getToken();
  }

  getUserInfo() {
    let _token = this.getToken().Token;
    let _decoded = jwtDecode(_token);
    return {
      username: _decoded.preferred_username,
      email: _decoded.email,
      phoneNumber: _decoded.phone_number,
      firstName: _decoded.r_first_name,
      identity: _decoded.r_identity
    };
  }
}
export default new Auth();
